import React, { ReactNode, useEffect, useRef } from 'react';
import styles from './styles.module.css';
import { useLayoutContext } from '@/context/LayoutContext';
import { productCardType } from '@/commonTypes';
import AppLink from '@/components/common/AppLink';

interface CardProps {
  children?: ReactNode;
  item?: productCardType;
  href?: string;
}

export default function Card({ children, item, href }: CardProps) {
  const cardRef = useRef<HTMLElement | null>(null);
  const { hoveredProduct, setHoveredproduct } = useLayoutContext();

  useEffect(() => {
    const handleWindowMouseMove = (ev: MouseEvent) => {
      const card = cardRef.current;

      if (!card) return;

      const blob = card.querySelector<HTMLDivElement>('.blob');
      const fakeblob = card.querySelector<HTMLDivElement>('.fakeblob');

      if (!blob || !fakeblob) return;

      const rect = fakeblob.getBoundingClientRect();

      blob.style.opacity = '1';

      blob.animate(
        [
          {
            transform: `translate(
              ${ev.clientX - rect.left - rect.width / 2}px,
              ${ev.clientY - rect.top - rect.height / 2}px
            )`,
          },
        ],
        {
          duration: 300,
          fill: 'forwards',
        },
      );
    };

    window.addEventListener('mousemove', handleWindowMouseMove);

    return () => {
      window.removeEventListener('mousemove', handleWindowMouseMove);
    };
  }, []);

  const handleMouseMove = (e: React.MouseEvent<HTMLElement>) => {
    const card = cardRef.current;

    if (!card) return;

    const rect = card.getBoundingClientRect();

    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const rotateY = ((x - centerX) / centerX) * 10;
    const rotateX = -((y - centerY) / centerY) * 10;

    card.style.transform = `
      perspective(1000px)
      rotateX(${rotateX}deg)
      rotateY(${rotateY}deg)
      scale3d(1.02, 1.02, 1.02)
    `;
  };

  const handleMouseLeave = () => {
    const card = cardRef.current;

    if (!card) return;

    setHoveredproduct && setHoveredproduct(undefined);
    card.style.transform = `
      perspective(1000px)
      rotateX(0deg)
      rotateY(0deg)
      scale3d(1,1,1)
    `;
  };
  const HeadTag: any = href ? AppLink : 'article';
  return (
    <HeadTag
      taregt={'_blank'}
      href={href}
      className={`${styles.card} card relative`}
      ref={cardRef}
      onMouseMove={handleMouseMove}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={() => {
        setHoveredproduct && setHoveredproduct(item);
      }}
    >
      {children}

      <div className="blob" />
      <div className="fakeblob" />
    </HeadTag>
  );
}
